import axios from "src/utils/axios";
import {
  getMesasSuccess,
  getZonasSuccess,
} from "src/redux/slices/mesas";
import {
  getProductsSuccess,
  getFrequentProductsSuccess,
} from "src/redux/slices/product";
import {
  getCategoriesSuccess,
  getTagsSuccess,
} from "src/redux/slices/categories";
import { setAlergenos } from "src/redux/slices/allergen";
import { getPaymentsSuccess } from "src/redux/slices/paymentMethods";
import { getDiscountsSuccess } from "src/redux/slices/discounts";
import { getCuentasSuccess } from "src/redux/slices/cuentas";
import { setStockProductos } from "src/redux/slices/gestion";
import { setUpcoming, setAlerts } from "src/redux/slices/bookings";
import { isBookingsAddOnInactive } from "src/utils/bookings/bookingRules";
import { setAeatErrorsBadge } from "src/redux/slices/aeatErrors";
import { setEmployeeCorrectionsList } from "src/redux/slices/employeeCorrections";
import { setScheduleAlerts } from "src/redux/slices/scheduleAlerts";

// Endpoint compuesto — obtiene en UNA petición TODO el snapshot inicial
// del TPV. El backend resuelve cada bloque en un IServiceScope propio
// (DbContext independiente) y los paraleliza con Task.WhenAll, así que
// el TTFB ≈ max(individual) en lugar de la suma. La única razón para
// separarlos aquí sería tener ETag distintos por bloque, pero como el
// contenido es dinámico (mesas cambian, bookings cambian) el ETag no
// aportaría — 1 request comprimida gana claramente.
//
// Antes: 12-15 GETs encadenados al login + navegación:
//   getMesas, GetZonas, getProducts, getCategories, getTags,
//   getFrequentProducts, getAlergenos, getPaymentMethods, getDiscounts,
//   getStockProductos, fetchUpcomingBookings, fetchBookingAlerts,
//   fetchAeatErrorsCount, pollEmployeeCorrectionsCount,
//   fetchScheduleAlerts…
// Ahora: 1 GET → 1 OPTIONS + 1 body comprimido.
//
// Parametrización: `include` puede pasar una lista para hidratar SOLO
// una parte del store (ej. al cambiar de vista donde sólo hacen falta
// mesas + zonas). Sin argumento → todo.
export function loadTpvBootstrap({ include, getAll = false } = {}) {
  return async (dispatch, getState) => {
    try {
      const params = {};
      if (include && include.length > 0) params.include = include.join(",");
      if (getAll) params.getAll = true;

      const response = await axios.get("bootstrap/tpv", { params });
      const data = response?.data ?? {};

      // Cada slice se hidrata sólo si el bloque llegó en la respuesta:
      // el endpoint omite las claves que no se pidieron (o que salieron
      // vacías), así que un `if (data.x)` basta como guard.
      //
      // Datos cuasi-estáticos:
      if (data.mesas) dispatch(getMesasSuccess(data.mesas));
      if (data.zonas) dispatch(getZonasSuccess(data.zonas));
      if (data.productos) dispatch(getProductsSuccess(data.productos));
      if (data.categorias) dispatch(getCategoriesSuccess(data.categorias));
      if (data.alergenos) dispatch(setAlergenos(data.alergenos));
      if (data.tags) dispatch(getTagsSuccess(data.tags));
      if (data.frequentProducts)
        dispatch(getFrequentProductsSuccess(data.frequentProducts));
      if (data.paymentMethods)
        dispatch(getPaymentsSuccess(data.paymentMethods));
      if (data.discounts) dispatch(getDiscountsSuccess(data.discounts));
      if (data.stockProductos)
        dispatch(setStockProductos(data.stockProductos));
      // Cuentas abiertas — se cargan aquí (una vez por recarga de vista)
      // para que el auto-vincular del PaymentDialog las tenga al abrir sin
      // pedirlas en cada apertura del modal.
      if (data.cuentas) dispatch(getCuentasSuccess(data.cuentas));

      // Datos dinámicos-corto plazo (topbar / TPV):
      // Sin add-on "Reservas online" no se pintan reservas en el TPV.
      if (isBookingsAddOnInactive(getState?.())) {
        dispatch(setUpcoming([]));
        dispatch(setAlerts([]));
      } else {
        if (data.bookingsUpcoming) dispatch(setUpcoming(data.bookingsUpcoming));
        if (data.bookingsAlerts) dispatch(setAlerts(data.bookingsAlerts));
      }
      if (data.aeatErrorsCount)
        dispatch(setAeatErrorsBadge(data.aeatErrorsCount.count ?? 0));
      if (data.pendingApprovals)
        dispatch(setEmployeeCorrectionsList(data.pendingApprovals));
      // `scheduleAlerts` hidrata el slice de fichajes. Antes vivía en
      // state local del `ScheduleAlertsBadge` (`useState`), lo que
      // provocaba que dos consumidores concurrentes se pisasen via
      // `staleGuard` (uno fetcheaba, el otro veía la key marcada y se
      // quedaba con `[]`). Con el slice ambos leen la misma fuente y
      // el bootstrap ahorra el GET adicional.
      if (data.scheduleAlerts?.alertas)
        dispatch(setScheduleAlerts(data.scheduleAlerts.alertas));
    } catch (_) {
      // Fallo silencioso: los slices se quedan con su estado previo.
      // El caller (authJwt) puede reaccionar a este error si quiere
      // (por ejemplo, mostrar snackbar), pero el TPV debe seguir
      // usable con lo que ya tiene cacheado.
    }
  };
}
